import React, {Component} from "react";
import Group, {GroupDescription, GroupHead} from "../../../Components/Group";
import Button from "../../../Components/Control/Button";
import './index.css';
import Grid, {GridButton, GridControls} from "../../../Components/Grid";
import Resource from "../../../Resource";
import {Tool} from "../../../App";
import Configuration from "../../../Server/Configuration";
import {connect} from "react-redux";
import {updateBase} from "../../../Redux/Actions/base";
import {ModalAction} from "../../../Components/Modal";
import ModalPolicy from "../../Modal/ModalPolicy";
import Prompt, {PromptControl} from '../../../Components/Prompt';
import Notif from '../../../Components/Notif';
import Perms from '../../../Perms';

class PagePolicies extends Component {
    constructor(props) {
        super(props);

        if (!Perms().CONFIGURATION.RULES.VIEW)
            props.history.push(Resource.ROUTE.HOME);

        this.state = {
            grid: {
                columnDefs: [{
                    headerName: '#',
                    headerTooltip: 'ردیف',
                    checkboxSelection: true,
                    headerCheckboxSelection: true,
                    valueGetter: row => row.node.rowIndex + 1,
                    filter: false,
                    maxWidth:80
                }, {
                    field: 'bloodGroupStr',
                    headerName: 'گروه خونی',
                    headerTooltip: 'گروه خونی',
                    cellClass: 'green'
                }, {
                    field: 'productTypeStr',
                    headerName: 'نوع فرآورده',
                    headerTooltip: 'نوع فرآورده'
                }, {
                    field: 'minStorageAmount',
                    headerName: 'حداقل موجودی',
                    headerTooltip: 'حداقل موجودی',
                    valueGetter: row => `${row.data.minStorageAmount} واحد`
                }, {
                    field: 'remainDaysToExpire',
                    headerName: 'شروع هشدار انقضا',
                    headerTooltip: 'شروع هشدار انقضا',
                    valueGetter: row => `${row.data.remainDaysToExpire} روز قبل`
                }, {
                    field: 'remainDaysToExpireCollectionDate',
                    headerName: 'شروع هشدار تازگی',
                    headerTooltip: 'شروع هشدار تازگی',
                    valueGetter: row => `${row.data.remainDaysToExpireCollectionDate} روز قبل`
                }, {
                    headerName: 'عملیات',
                    headerTooltip: 'عملیات',
                    pinned: 'left',
                    sortable: false,
                    filter: false,
                    minWidth: 120,
                    hide: !(Perms().CONFIGURATION.RULES.UPDATE || Perms().CONFIGURATION.RULES.DELETE),
                    enableRowGroup: false,
                    cellRenderer: 'control'
                }],
                frameworkComponents: {
                    control: row => {
                        return <GridControls>
                            {Perms().CONFIGURATION.RULES.UPDATE && <GridButton type={"button"} theme={'edit'} title={'ویرایش'} onClick={this.update.bind(this, row.data)}/>}
                            {Perms().CONFIGURATION.RULES.DELETE && <GridButton type={"button"} theme={'delete'} title={'حذف'} onClick={this.delete.bind(this, row.data)}/>}
                        </GridControls>;
                    }
                },
                getContextMenuItems: params => {
                    if (params.node)
                        return [{
                            name: 'ویرایش',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.EDIT1.BLACK}"/>`,
                            action: this.update.bind(this, params.node.data),
                            disabled: !Perms().CONFIGURATION.RULES.UPDATE
                        }, {
                            name: 'حذف',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.TRASH1.BLACK}"/>`,
                            action: this.delete.bind(this, params.node.data),
                            disabled: !Perms().CONFIGURATION.RULES.DELETE
                        },
                            'separator',
                            ...params.defaultItems];
                },
                onRowDoubleClicked: row => {
                    this.ref.modalPolicy.current.open(row.data, Perms().CONFIGURATION.RULES.UPDATE ? ModalAction.UPDATE : ModalAction.VIEW);
                }
            },
            rowData: [],
            selectedRows: [],
            gridContext: null
        };

        this.ref = {
            grid: React.createRef(),
            modalPolicy: React.createRef(),
            prompt: React.createRef()
        };
    }

    componentDidMount() {
        const {state, props} = this;

        const grid = Tool.applyGridDefaultSettings(props.gridDefaultSettings, state.grid);

        if (grid) {
            this.setState({grid});
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return this.state.grid !== nextState.grid ||
            this.state.rowData !== nextState.rowData;
    }

    render() {
        return <React.Fragment>
            <Group className={'PagePolicies-group mar-10'}>
                <GroupHead title={'لیست قوانین'}>
                    {Perms().CONFIGURATION.RULES.INSERT && <Button className={'mar-s-4'} theme={'blue'} onClick={this.updateClickHandler.bind(this)}>افزودن قانون</Button>}
                </GroupHead>
                <GroupDescription>لیست قوانین مدیریت بانک خون از این قسمت قابل مشاهده می باشد.</GroupDescription>
                <Grid refer={this.ref.grid} id={'policies'} {...this.state.grid} rowData={this.state.rowData} onGridReady={this.gridReadyHandler.bind(this)} onSelectionChanged={this.gridSelectionHandler.bind(this)}/>
            </Group>
            <ModalPolicy refer={this.ref.modalPolicy} onSuccess={this.updateGrid.bind(this)}/>
            <Prompt ref={this.ref.prompt}/>
        </React.Fragment>;
    }

    updateGrid() {
        this.ref.grid.current.loading();

        Configuration.policyList()
            .then(list => {
                this.ref.grid.current.loading(false);

                this.setState({rowData: list});
            })
            .catch(message => {
                this.ref.grid.current.error();
            });
    }

    gridReadyHandler(params) {
        this.updateGrid();

        this.setState({gridContext: params});
    }

    gridSelectionHandler(rows) {
        this.setState({selectedRows: rows});
    }

    delete(row, props = {loading: _ => null}) {
        this.ref.prompt.current.open({
            title: 'اخطار',
            description: 'آیا می خواهید قانون مورد نظر را حذف کنید؟',
            buttons: PromptControl.YES_NO,
            onClose: button => {
                if (button.id === PromptControl.YES) {
                    props.loading();

                    Configuration.deletePolicy({
                        productMaintanceConditionId: row?.productMaintanceConditionId
                    }).then(_ => {
                        props.loading(false);

                        this.updateGrid();

                        new Notif(Resource.STRING.FETCH.DELETE_SUCCESSFUL).show();
                    }).catch(message => {
                        props.loading(false);

                        new Notif({message, theme: 'error'}).show();
                    });
                }
            }
        });
    }

    update(row) {
        this.ref.modalPolicy.current.open(row, ModalAction.UPDATE);
    }

    updateClickHandler() {
        this.ref.modalPolicy.current.open(this.state.rowData, ModalAction.INSERT);
    }
}

const mapStateToProps = state => {
    return {
        gridDefaultSettings: state.grid.defaultSettings
    };
};

const mapDispatchToProps = dispatch => {
    return {
        updateBase: props => dispatch(updateBase(props))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PagePolicies);